const spanWrapText = (targets) => {
  targets.forEach( function (target) {
    let nodes = [...target.childNodes];
    let textBox = '';
    nodes.forEach( function (node) {
      if (node.nodeType == 3) { //テキストの場合
        let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
        text.split('').forEach(function (t) {
          if (t !== " ") {
          textBox += '<span class="char">' + t + '</span>';
        } else {
          textBox += t;
        }
      });
    } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
      let childNodes = [...node.childNodes];
      let childTextBox = '';
      childNodes.forEach( function (childeNode) {
        if (childeNode.nodeType == 3) { //テキストの場合
          let childeText = childeNode.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
          childeText.split('').forEach(function (ct) {
            if (ct !== " ") {
              childTextBox += '<span class="char">' + ct + '</span>';
            } else {
              childTextBox += ct;
            }
          });
        } else if (childeNode.contains(node) == true) {
            // そのまま連結
            childTextBox = childTextBox + childeNode.outerHTML;
        } else {
            childTextBox = childTextBox + childeNode.outerHTML;
        }
      })

      node.innerHTML = childTextBox
      textBox = textBox + node.outerHTML;

    } else { // テキストではなく、br要素などspan要素以外の要素を持つ
        textBox = textBox + node.outerHTML;
      }
    })
    target.innerHTML = textBox
  })

  return targets;
};

export default spanWrapText;